import ReportDocument from "./ReportDocument";

const MISTrips = ({ data = [] }) => {
  const columns = [
    { label: "Trip ID", key: "trip_number" },
    { label: "Trip Name", key: "title" },
    { label: "Employee Name", key: "employee_name" },
    { label: "Purpose", key: "business_purpose" },
    { label: "Submitted On", key: "submitted_on" },
    { label: "Cost Center", key: "cost_center" },
    { label: "Project", key: "project" },
    { label: "Status", key: "status" },
  ];

  const customFields = data[0]?.custom_fields?.map((ele) => ele.key) ?? [];

  return (
    <ReportDocument columns={columns} data={data} customFields={customFields} />
  );
};

export default MISTrips;
